import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import FilterSidebar from './components/FilterSidebar';
import SearchAndSort from './components/SearchAndSort';
import BookGrid from './components/BookGrid';
import Icon from '../../components/AppIcon';
import bookSlides from "../../data/bookSlides";
import Footer from "../../components/ui/Footer";

const CompleteWorksLibrary = () => {
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const [filters, setFilters] = useState({});
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);

  useEffect(() => {
    setBooks(bookSlides);
    setFilteredBooks(bookSlides);
    setLoading(false);
  }, []);

  useEffect(() => {
    let filtered = [...books];

    if (searchQuery) {
      const query = searchQuery?.toLowerCase();
      filtered = filtered?.filter(book => 
        book?.title?.toLowerCase()?.includes(query) ||
        book?.sinopsis?.toLowerCase()?.includes(query) ||
        book?.themes?.some(theme => theme?.toLowerCase()?.includes(query)) ||
        (book?.series && book?.series?.toLowerCase()?.includes(query))
      );
    }

    // Apply category filters
    Object.entries(filters)?.forEach(([category, selectedOptions]) => {
      if (selectedOptions && selectedOptions?.length > 0) {
        switch (category) {
          case 'themes':
            filtered = filtered?.filter(book =>
              selectedOptions?.some(option => 
                book?.themes?.some(theme => 
                  theme?.toLowerCase()?.replace(/\s+/g, '-') === option
                )
              )
            );
            break;
          case 'series':
            filtered = filtered?.filter(book => {
              if (selectedOptions?.includes('julia-navarro')) {
                return !book?.series;
              }
              return selectedOptions?.some(option =>
                book?.series && book?.series?.toLowerCase()?.replace(/\s+/g, '-') === option
              );
            });
            break;
        }
      }
    });

    // Apply sorting
    switch (sortBy) {
      case 'newest':
        filtered?.sort((a, b) => b?.year - a?.year);
        break;
      case 'oldest':
        filtered?.sort((a, b) => a?.year - b?.year);
        break;
      case 'title-asc':
        filtered?.sort((a, b) => a?.title?.localeCompare(b?.title));
        break;
      case 'title-desc':
        filtered?.sort((a, b) => b?.title?.localeCompare(a?.title));
        break;
      default: // relevance
        // Keep original order or implement relevance scoring
        break;
    }

    setFilteredBooks(filtered);
  }, [books, searchQuery, filters, sortBy]);

  const handleAddToFavorites = (bookId, isFavorite) => {
    setBooks(prevBooks =>
      prevBooks?.map(book =>
        book?.id === bookId ? { ...book, isFavorite } : book
      )
    );
  };

  const handleAddToCart = (book) => {
    console.log('Adding to cart:', book?.title);
    // Implement cart functionality
  };

  const toggleFilterSidebar = () => {
    setIsFilterSidebarOpen(!isFilterSidebarOpen);
  };

  return (
    <>
      <div className="min-h-screen ">
        <Header />
        
        <div className="pt-16 lg:pt-20 ">
          <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-6">
            {/* Page Header */}
            <div className="text-center mb-6 md:mb-8">
              <div className="flex items-center justify-center space-x-2 mb-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary/10">
                  <Icon name="Library" size={20} className="text-primary" />
                </div>
                <h1 className="font-headline text-2xl sm:text-3xl lg:text-4xl font-bold text-primary">
                  LIBROS
                </h1>
              </div>
            </div>


            <div className="flex flex-col lg:flex-row lg:gap-8">
              {/* Filter Sidebar - Solo Desktop */}
              <div className="hidden lg:block w-80 flex-shrink-0 ">
                <FilterSidebar
                  filters={filters}
                  onFiltersChange={setFilters}
                  isOpen={true}
                  onToggle={() => {}}
                />
              </div>

              {/* Filter Sidebar - Solo Mobile */}
              <div className="block lg:hidden">
                <FilterSidebar
                    filters={filters}
                    onFiltersChange={setFilters}
                    isOpen={isFilterSidebarOpen}
                    onToggle={toggleFilterSidebar}
                />
              </div>

              {/* Main Content */}
              <div className="flex-1 min-w-0">
                {/* Search and Sort */}
                <SearchAndSort
                  searchQuery={searchQuery}
                  onSearchChange={setSearchQuery}
                  sortBy={sortBy}
                  onSortChange={setSortBy}
                  viewMode={viewMode}
                  onViewModeChange={setViewMode}
                  totalResults={filteredBooks?.length}
                  onFilterToggle={toggleFilterSidebar}
                />

                {/* Books Grid */}
                <BookGrid
                  books={filteredBooks}
                  viewMode={viewMode}
                  loading={loading}
                  onAddToFavorites={handleAddToFavorites}
                  onAddToCart={handleAddToCart}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    </>
  );
};

export default CompleteWorksLibrary;